/* eslint-disable custom-import/dynamic-import-chunkname */
/* eslint-disable no-console */

import queryString from 'query-string';
import { isSDK } from '@bingads-webui-campaign-react/sdk-utils';
import './legacy-dep-bootstrap/bootstrap.config';
import { checkQueryParams } from './global-init/query-param-checker';

// if user put wrong values for known query params (uid, cid, aid), restores it per server context
checkQueryParams(window.serverContext);

// remove skipcccache from URL, this should only be used once to refresh sever cache, then removed
const query = queryString.parse(window.location.search);
delete query.skipcccache;
window.history.replaceState(
  {},
  document.title,
  `${window.location.pathname}?${queryString.stringify(query, { sort: false })}${window.location.hash}`
);

if (isSDK()) {
  import(/* webpackMode: 'eager' */'./sdk/sdk-bootstrap');
} else {
  // eslint-disable-next-line no-unused-expressions
  import(/* webpackMode: 'eager' */'./bootstrap');
}
